module.exports = __webpack_public_path__ + "static/media/NSHP.67240ecb.png";